/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Col_Session_TimeInputs */

const vi_stocktake_col_session_time = /** @type {(inputs: Stocktake_Col_Session_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên`)
};

/**

* @param {Stocktake_Col_Session_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_col_session_time = /** @type {((inputs?: Stocktake_Col_Session_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Col_Session_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_col_session_time(inputs)
});